const stripHtml = (html) => (html ? html.replace(/<[^>]*>/g, '') : html);

export default stripHtml;
